import { WebPlugin } from "@capacitor/core";
export class NativeWeb extends WebPlugin {
    async getAppMetaData() {
        return {
            version: {
                versionName: "1.16.0",
                versionCode: 2025012700,
            },
        };
    }
}
//# sourceMappingURL=web.js.map